import Survey from "models/Survey";

export const SET_SURVEY_LIST = "surveyList/SET_SURVEY_LIST";

export const setSurveyList = (customerId, surveys) => ({
  type: SET_SURVEY_LIST,
  customerId,
  surveys: surveys.map(survey => new Survey(survey))
});

const initialState = {
  customerId: null,
  surveys: []
};

const surveyList = (state = initialState, action) => {
  switch (action.type) {
    case SET_SURVEY_LIST: {
      return {
        ...state,
        customerId: action.customerId,
        surveys: action.surveys
      };
    }
    default:
      return state;
  }
};

export default surveyList;



// WEBPACK FOOTER //
// ./src/redux/modules/surveyList.js